// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab7241b6","453":"6616d21f","455":"4020bc36","762":"217dcb6c","952":"f98b7596","977":"fac57fca"}[chunkId] + ".chunk.js";
};